export default "/_next/static/images/team-life-bg@2x-a242df237aa0095ba88c2712164291fd.png";